<!-- Google Map -->
<div class="google-maps">
	<div class="mapouter">
	   <div class="gmap_canvas">
	      <iframe class="border-rad" width="{{width}}" height="{{height}}" id="gmap_canvas" src="https://maps.google.com/maps?q=бул. Липник 123, Русе, България&t=&z=14&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
	      </iframe>embed google map by <a href="http://www.embedgooglemap.net">embedgooglemap.net</a>
	   </div>
	</div>
</div>
